/**
 * Emergency stop for the AI chatbot in the Help Center.
 * If set to `true`, the user will see the normal self-serve flow instead of the chatbot.
 */
export const HELP_CENTER_AI_CHATBOT_EMERGENCY_STOP =
  'HELP_CENTER_AI_CHATBOT_EMERGENCY_STOP';
